<template>
  <Layout>
    <div class="layout__wrapper">
      <section>
        <div v-if="highlight" class="banner banner-summaries">
          <div class="container banner__container">
            <div class="banner__text-box text-center">
              <div itemscope itemtype="https://schema.org/CreativeWork">
                <h1 class="banner__title" itemprop="headline">
                  <a :href="bookUrl">{{ highlight.content.doc.title }}</a>
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div v-if="highlight" class="highlight-view">
          <div class="container">
            <div class="blockquote-slider">
              <div class="blockquote-slider__item">
                <blockquote
                  class="blockquote-slider__text highlight-view__quote"
                >
                  {{ highlight.quote }}
                </blockquote>
                <hr v-if="highlight.text" class="my-2" />
                <p v-if="highlight.text" class="highlight-view__note">
                  <span>{{ highlight.text }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </Layout>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import Layout from '@/app/components/Layout.vue'

import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'
import type { AnnotationWithContent } from '@/models/interfaces'
import { assertNotNull } from '@/helpers/typing'

const route = useRoute()
const router = useRouter()

const highlight = ref<AnnotationWithContent | null>(null)

onBeforeMount(async () => {
  try {
    highlight.value = await backend.getHighlight(
      route.params.highlight_id as string,
    )
  } catch (error: any) {
    if (error.request && error.request.status === 404) {
      // Redirect to the non-existing page
      router.push({ name: 'not_found' })
    } else {
      Sentry.captureException(error)
      throw error
    }
  }
})

const bookUrl = computed(() => {
  const content = assertNotNull(highlight.value).content
  return `/app/book/${content.doc.url_slug}/${content.url_slug}/`
})
</script>
